import React, { useState } from 'react';
import StatusBadge from '../../StatusBadge';
import DownloadProcessButton from './DownloadProcessButton';
import RestartProcessButton from './RestartProcessButton';
import { restartContentExtraction } from '../../../apis/restartContentExtraction';
import { toast } from 'react-toastify';
import { deleteContentExtraction } from '../../../apis/scormUpload';
import { formatDate, formatTime } from '../../../lib/utils';

const ScormProcess = ({ proc }) => {
    const [localProc, setLocalProc] = useState(proc);

    const handleRestart = async () => {
        if (!window.confirm('Are you sure you want to restart this extraction process?')) return;
        try {
            const response = await restartContentExtraction(localProc.id);
            // Find the extraction in the response that matches this proc.id
            const updatedExtraction = response.scorm_file.content_extractions.find((ex) => ex.id === localProc.id);
            if (updatedExtraction) {
                setLocalProc((prev) => ({
                    ...prev,
                    status: updatedExtraction.status,
                    started_at: updatedExtraction.started_at,
                    finished_at: updatedExtraction.finished_at,
                    download_link: updatedExtraction.download_link,
                }));
            }
            toast.success('Restart requested successfully.');
        } catch (err) {
            toast.error('Failed to restart extraction: ' + err);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm('Are you sure you want to delete this extraction process?')) return;
        try {
            await deleteContentExtraction(localProc.id);
            toast.success('Extraction deleted successfully.');
            setLocalProc(null);
        } catch (err) {
            toast.error('Failed to delete extraction: ' + err);
        }
    };

    return (
        localProc && (
            <div
                className="list-group-item my-1 d-flex flex-wrap align-items-center justify-content-between mb-1 px-4 py-3 border-0 bg-light shadow-sm rounded-2 border-start border-4 border-primary"
                style={{ minHeight: 70 }}
            >
                <div className="d-flex align-items-center flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="me-3 text-primary" style={{ fontSize: 28 }}>
                        <i className="bi bi-gear-fill"></i>
                    </div>
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <div className="fw-semibold text-dark text-truncate" style={{ maxWidth: 220 }}>
                            {localProc.file_name || '-'}
                        </div>
                        <div className="small text-muted mt-1">
                            <i className="bi bi-calendar-fill me-1"></i>
                            {formatDate(localProc.started_at)}
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-3 flex-wrap mt-3 mt-md-0">
                    <StatusBadge status={localProc.status} />
                    <span className="small text-muted ms-2">
                        <i className="bi bi-clock-fill"></i> {formatTime(localProc.started_at)}
                    </span>
                    {localProc.finished_at && (
                        <span className="small text-muted ms-2">
                            <i className="bi bi-flag-fill text-success"></i> {formatTime(localProc.finished_at)}
                        </span>
                    )}
                    <DownloadProcessButton downloadLink={localProc.download_link} status={localProc.status} />
                    <RestartProcessButton onRestart={handleRestart} status={localProc.status} />
                    {localProc.status !== 'processing' && (
                        <button className="btn btn-sm btn-danger rounded-pill" onClick={handleDelete}>
                            <i className="bi bi-trash"></i> Delete
                        </button>
                    )}
                </div>
            </div>
        )
    );
};

export default ScormProcess;
